import * as React from "react";
import {FormBodyProps} from "../../common/props/FormBodyProps";
import SectionView from "../../layout/section/SectionView";
import Row from "../../layout/Row";
import InputFormGroup from "../../../hiberUiKit/src/molecules/FormGroup/InputFormGroup";
import Col from "../../layout/Col";
import FinanceProductForm from "./FinanceProductForm";
import RangeNumberInputFormGroup from "../../ui/form/RangeNumberInputFormGroup";
import CheckboxFormGroup from "../../ui/form/CheckboxFormGroup";
import {FormField} from "../../../validation/FormField";
import {none} from "ts-option";


type Props = FormBodyProps<FinanceProductForm>

export default class FinanceProductFormBody extends React.PureComponent<Props> {
	render() {
		return (
			<SectionView>
				<Row>
					<Col xl={6} md={6}>
						<InputFormGroup label="Label"
										placeholder="Enter label"
										field={this.props.form.label}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.label)}/>
					</Col>
					<Col xl={6} md={6}>
						<InputFormGroup label="Provider"
										placeholder="Enter provider"
										field={this.props.form.provider}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.provider)}/>
					</Col>
				</Row>
				<Row>
					<Col xl={6} md={6}>
						<InputFormGroup label="Description"
										placeholder="Enter description"
										field={this.props.form.description}
										onChange={this.props.onFieldChange}
										focus={this.props.form.hasFocus(this.props.form.description)}/>
					</Col>
					<Col xl={6} md={6}>
						<RangeNumberInputFormGroup field={this.props.form.annualPercentageRate}
												   minValue={0}
												   maxValue={100}
												   placeholder={"Enter annual percentage rate"}
												   onChange={this.props.onFieldChange}
												   label={"Annual percentage rate (%)"}
												   focus={this.props.form.hasFocus(this.props.form.annualPercentageRate)}
												   maxDecimalPlaces={2}/>
					</Col>
				</Row>
				<Row>
					<Col xl={6} md={6}>
						<CheckboxFormGroup field={this.props.form.fee}
										   onChange={this.onHasFeeChanged}
										   label={"Has fee"}
										   style={{marginTop: "30px"}}/>
					</Col>
					<Col xl={6} md={6}>
						<RangeNumberInputFormGroup field={this.props.form.feePercentage}
												   minValue={0}
												   maxValue={100}
												   placeholder={"Enter Fee"}
												   onChange={this.props.onFieldChange}
												   label={"Fee (%)"}
												   focus={this.props.form.hasFocus(this.props.form.feePercentage)}
												   maxDecimalPlaces={2}
												   disabled={!this.props.form.fee.getValue()}/>
					</Col>
				</Row>
				<Row>
					<Col xl={6} md={6}>
						<CheckboxFormGroup field={this.props.form.disabled}
										   onChange={this.props.onFieldChange}
										   label={"Disabled"}/>
					</Col>
				</Row>
			</SectionView>
		);
	}

	onHasFeeChanged = (feeField: FormField<boolean>) => {
		let feePercentageField = this.props.form.feePercentage;
		if (!feeField.getValue()) {
			feePercentageField = feePercentageField.updateValue(none)
		}
		this.props.onFieldsChange([feeField, feePercentageField])
	}
}
